/* eslint-disable prettier/prettier */
import { DeleteIcon } from 'assets/svg'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { categoryService, mediaService } from 'services'
import store from 'store'
import { _object } from 'utils/interfaces'

const TopSellingCategories = () => {
  const [category, setCategory] = useState<_object>({})
  const [selectedFile, setSelectedFile] = useState<_object>({})
  const [isUploading, setIsUploading] = useState<string | null>(null)

  const getCategories = () => {
    categoryService.getCategories({ per_page: 999 }).then((results: _object) => {
      setCategory(results)
    })
  }
  useEffect(() => {
    getCategories()
  }, [])

  const handleChange = (value: boolean, id: string) => {
    categoryService
      .UpdateCategory(id, {
        home_page_display: value
      })
      .then((result: _object) => {
        if (result.error === false) {
          getCategories()
        }
      })
  }

  const handleChangeTopSelling = (value: boolean, id: string) => {
    categoryService
      .UpdateCategory(id, {
        top_selling: value
      })
      .then((result: _object) => {
        if (result.error === false) {
          getCategories()
        }
      })
  }

  const handleImageChange = (e: _object, id: string) => {
    const file = e.target.files ? e.target.files[0] : null
    if (file) {
      setSelectedFile({ file: file, id: id })
    }
  }
  useEffect(() => {
    if (!selectedFile.id) return
    setIsUploading(selectedFile.id)
    const uploadImage = async () => {
      const data = new FormData()
      if (selectedFile.id) {
        data.append('entity_id', selectedFile.id)
      }
      data.append('entity_type', 'category')
      data.append('key', 'category_image')
      data.append('files', selectedFile.file)
      const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : ''
        },
        body: data
      })

      const result = await response.json()
      if (result.error === false) {
        toast.success(result.message || 'Image uploaded successfully.', {
          autoClose: 3000
        })
        getCategories()
      } else if (result.error === true) {
        toast.error(result.message || 'Image not uploaded.', {
          autoClose: 3000
        })
      }
      setIsUploading(null)
    }

    uploadImage()
  }, [selectedFile])

  const deleteSlide = (id: string) => {

    if (window.confirm('Are you sure you want to delete this slide?')) {
      mediaService.deleteMediaData(id).then((results: _object) => {
        if (results?.error === false) {
          getCategories()
        }
      })
    }
  }

  return (
    <>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 ">Home Page Display</th>
              <th className="px-4 py-3 ">Top selling</th>
              <th className="py-3 text-sm">
                <p className="ms-4 font-semibold text-sm text-gray-900">Image</p>
                <span className='text-[10px] text-[#969494] font-medium'>100W × 100H | 1:1</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-sm">
            {category.items?.length > 0 ? (
              category?.items?.map((item: _object, i: number) => {
                return (
                  <tr className="hover:bg-gray-50" key={i}>
                    <td className="px-4 py-3">{i + 1}</td>
                    <td className="px-4 py-3">{item.name}</td>
                    <td className="px-4 py-3">
                      <label className="inline-flex cursor-pointer items-center">
                        <input
                          type="checkbox"
                          // value={item?.home_page_display}
                          className="peer sr-only"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleChange(e.target.checked, item.id)
                          }
                          checked={item?.home_page_display}
                        />
                        <div className="peer relative h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-purple-900 peer-focus:ring-0 peer-focus:ring-purple-900 peer-focus:outline-none after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white rtl:peer-checked:after:-translate-x-full dark:border-gray-600 dark:bg-gray-700 dark:peer-checked:bg-purple-900 dark:peer-focus:ring-purple-900"></div>
                      </label>
                    </td>
                    <td className="px-4 py-3">
                      <label className="inline-flex cursor-pointer items-center">
                        <input
                          type="checkbox"
                          // value={item?.home_page_display}
                          className="peer sr-only"
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleChangeTopSelling(e.target.checked, item.id)
                          }
                          checked={item?.top_selling}
                        />
                        <div className="peer relative h-6 w-11 rounded-full bg-gray-200 peer-checked:bg-purple-900 peer-focus:ring-0 peer-focus:ring-purple-900 peer-focus:outline-none after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-white rtl:peer-checked:after:-translate-x-full dark:border-gray-600 dark:bg-gray-700 dark:peer-checked:bg-purple-900 dark:peer-focus:ring-purple-900"></div>
                      </label>
                    </td>
                    <td className="px-4 py-3 flex items-center">
                      {item?.image ? (
                        <>
                          <div className="relative inline-block h-12 w-12">
                            <img
                              src={item?.image}
                              alt={item.title}
                              className="h-full w-full rounded object-cover"
                            />
                            <button
                              type="button"
                              onClick={() => deleteSlide(item.image_id)}
                              title="Delete Slide"
                              className="absolute top-0 right-0 rounded-full bg-white p-1 shadow-sm hover:bg-gray-100"
                            >
                              <DeleteIcon className="h-[16px] w-[16px] text-red-500" />
                            </button>
                          </div>
                        </>
                      ) : (
                        <label htmlFor={item.id}>
                          <div className="flex h-12 w-12 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
                            <input
                              type="file"
                              id={item.id}
                              accept=".png, .jpg, .jpeg"
                              onChange={(e: _object) => handleImageChange(e, item.id)}
                              className="hidden"
                            />
                            {isUploading === item.id ? (
                              <svg
                                className="h-8 w-8 animate-spin text-purple-900"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                ></path>
                              </svg>
                            ) : (
                              <>
                                <span className="text-2xl font-bold text-purple-900">+</span>
                              </>
                            )}
                          </div>
                        </label>
                      )}
                    </td>
                  </tr>
                )
              })
            ) : (
              <SliderSkeleton />
            )}
          </tbody>
        </table>
      </div>
    </>
  )
}
export default TopSellingCategories

const SliderSkeleton = () => {
  return (
    <>
      <tr className="animate-pulse">
        <td className="px-4 py-3">
          <div className="h-4 w-6 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-32 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
        <td className="px-4 py-3">
          <div className="h-4 w-12 rounded bg-gray-300"></div>
        </td>
      </tr>
    </>
  )
}
